'use client';

import { c as _c } from "react/compiler-runtime";
import { useDatabaseContext } from '@shared/utils/context/DatabaseContext';
import DatabaseDisabledState from './DatabaseDisabledState';
interface DatabaseGuardProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  showRetryButton?: boolean;
}
const DatabaseGuard: React.FC<DatabaseGuardProps> = t0 => {
  const $ = _c(6);
  const {
    children,
    title,
    description,
    showRetryButton: t1
  } = t0;
  const showRetryButton = t1 === undefined ? true : t1;
  const {
    state: t2
  } = useDatabaseContext();
  const {
    disabled
  } = t2;
  if (disabled) {
    let t3;
    if ($[0] !== description || $[1] !== showRetryButton || $[2] !== title) {
      t3 = <DatabaseDisabledState title={title} description={description} showRetryButton={showRetryButton} />;
      $[0] = description;
      $[1] = showRetryButton;
      $[2] = title;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== children) {
    t3 = <>{children}</>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default DatabaseGuard;